var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"svg-icon-hover-box"},[_c('svg-icon',{attrs:{"class-name":"icon-class icon-class-default","icon-class":_vm.svgIconClass}}),_c('svg-icon',{attrs:{"class-name":"icon-class icon-class-hover","icon-class":_vm.svgIconClassHover}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }